import React, { Component } from 'react';
import { chunk, range } from 'lodash';
import { List, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import TagPreviewDetailPageImg from '../TagPreviewDetailPageImg';
import './TagPreviewDetailPageGallery.scss';

class TagPreviewDetailPageGallery extends Component {
  constructor(props) {
    super(props);

    this.cache = new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 1098,
    });
  }

  render() {
    const { itemList } = this.props;
    const galleryOnePatternList = chunk(itemList, 16);

    return (
      <div className="tag-preview-main-detail-page-gallery">
        <List
          width={356}
          height={453}
          rowCount={galleryOnePatternList.length}
          rowHeight={this.cache.rowHeight}
          deferredMeasurementCache={this.cache}
          overscanRowCount={5}
          rowRenderer={({ key, index, parent, style }) => (
            <CellMeasurer key={key} cache={this.cache} parent={parent} columnIndex={0} rowIndex={index}>
              <div className="tag-detail-item-gallery-cycle" style={style}>
                <div className="tag-detail-item-gallery-cycle-1-area">
                  {range(0, 2).map((itemIndex) => (
                    <TagPreviewDetailPageImg
                      className="medium"
                      key={itemIndex}
                      item={galleryOnePatternList[index][itemIndex]}
                    />
                  ))}
                </div>

                <div className="tag-detail-item-gallery-cycle-2-area">
                  <TagPreviewDetailPageImg className="large" item={galleryOnePatternList[index][2]} />

                  <div className="inner-vertical">
                    {range(3, 5).map((itemIndex) => (
                      <TagPreviewDetailPageImg
                        className="small"
                        key={itemIndex}
                        item={galleryOnePatternList[index][itemIndex]}
                      />
                    ))}
                  </div>
                </div>

                <div className="tag-detail-item-gallery-cycle-3-area">
                  {range(5, 8).map((itemIndex) => (
                    <TagPreviewDetailPageImg
                      className="small"
                      key={itemIndex}
                      item={galleryOnePatternList[index][itemIndex]}
                    />
                  ))}
                </div>

                <div className="tag-detail-item-gallery-cycle-1-area">
                  {range(8, 10).map((itemIndex) => (
                    <TagPreviewDetailPageImg
                      className="medium"
                      key={itemIndex}
                      item={galleryOnePatternList[index][itemIndex]}
                    />
                  ))}
                </div>

                <div className="tag-detail-item-gallery-cycle-4-area">
                  <div className="inner-vertical">
                    <TagPreviewDetailPageImg className="small" item={galleryOnePatternList[index][10]} />

                    <TagPreviewDetailPageImg className="small" item={galleryOnePatternList[index][12]} />
                  </div>

                  <TagPreviewDetailPageImg className="large" item={galleryOnePatternList[index][11]} />
                </div>

                <div className="tag-detail-item-gallery-cycle-3-area">
                  {range(13, 16).map((itemIndex) => (
                    <TagPreviewDetailPageImg
                      className="small"
                      key={itemIndex}
                      item={galleryOnePatternList[index][itemIndex]}
                    />
                  ))}
                </div>
              </div>
            </CellMeasurer>
          )}
        />
      </div>
    );
  }
}

export default TagPreviewDetailPageGallery;
